import { getTranslatedString } from 'helpers/i18n';

export const StandardNotice = 'standard';
export const LegalNotice = 'legal';
export const NoticeOfEntryNotice = 'notice_of_entry';
export const UrgentNotice = 'urgent';

const translatePrefix = 'landlordPortal.noticeForm.type';

export const NoticeTypes = [
  {
    label: getTranslatedString(`${translatePrefix}.standard`),
    value: StandardNotice,
  },
  {
    label: getTranslatedString(`${translatePrefix}.legal`),
    value: LegalNotice,
  },
  {
    label: getTranslatedString(`${translatePrefix}.noticeOfEntry`),
    value: NoticeOfEntryNotice,
  },
  {
    label: getTranslatedString(`${translatePrefix}.urgent`),
    value: UrgentNotice,
  },
];

export const legalNoticeAcceptedFileTypes =
  '.jpg, .jpeg, .png, .csv, .pdf, .doc, .docx, .xls, .xlsx';
